export const DEPARTURE = {
  KOR: {
    title: '출국 예정일을 선택해주세요.',
    tooltipTitle: '출국예정일 주의사항',
    firstTitle: '① 환급대상',
    firstContents:
      '환급대상 : 입국일로부터 3개월 이내 출국자. 출국일은 본인의 입국일로부터 3개월이 초과되지 않도록 지정해주세요.',
    secondTitle: '② 출국예정일 수정',
    secondContents:
      '최초 환급일 기준으로 이전 일은 선택이 불가합니다. 수정은 출국일 최소 1~3일 전에 수정 바랍니다.',
    btnOk: '확인',
  },
  ENG: {
    title: 'Select Departure date',
    tooltipTitle: 'Expected Departure Date Precautions',
    firstTitle: '① Eligible shoppers',
    firstContents:
      'Leave the country within three months from the purchase date, and meet the following qualifications: Foreigner (Stayed less than six months in Korea)',
    secondTitle: '② Modifying the departure date.',
    secondContents:
      'You cannot select the past date based on the first refund date. Please correct it at least 1 days before the departure date',
    btnOk: 'Confirm',
  },
};
